import { render, staticRenderFns } from "./BankSelectionDetailsModal.vue?vue&type=template&id=65ff3626"
import script from "./BankSelectionDetailsModal.vue?vue&type=script&lang=js"
export * from "./BankSelectionDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./BankSelectionDetailsModal.vue?vue&type=style&index=0&id=65ff3626&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports